// extracted by mini-css-extract-plugin
module.exports = {"modalStyles":"RestockedModal_modalStyles__450xa","bodyModalStyles":"RestockedModal_bodyModalStyles__ZFDED"};